module.exports = __webpack_public_path__ + "static/media/teaant.1402f3bb.svg";